export default __webpack_public_path__ + "static/purple-905514ac8159270aea45a7d2a0c4385e.gif";